import React from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const FeatureComponent: MyComponentType<Props> = (props: Props) => {
  const { elements, privateSchema, id, parentNodeIsBody } = props;
  // @ts-ignore
  const { isReverse } = privateSchema;

  const flexRow = isReverse ? 'md:flex-row-reverse' : 'md:flex-row';
  const flexPadding = isReverse ? 'md:pr-24' : 'md:pl-24';

  return (
    <div
      style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
      className={`flex ${flexRow} flex-col`}
      id={id}
    >
      <props.ComponentBasicRender
        {...toJS(elements[0])}
        className="w-full md:w-1/2 flex flex-col justify-center"
        styles={{
          [isReverse ? 'marginLeft' : ' marginRight']: privateSchema?.marginRight,
        }}
      />
      <div className="w-full md:w-1/2">
        <div className={'h-full flex flex-col justify-center'}>
          <div className={flexPadding}>
            <props.ComponentBasicRender tip="标题文本组件" {...toJS(elements[1])} />
          </div>
          <div className={flexPadding}>
            <props.ComponentBasicRender tip="内容文本组件" {...toJS(elements[2])} />
          </div>
        </div>
      </div>
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/FeatureComponentDefinition'));

FeatureComponent.definition = {
  // id: 'feature-component',
  id: ComponentIdEnum.FEATURE_COMPONENT,
  name: '卖点组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/D4UIJKSXjA1G0MP4klaTU.png?image_process=resize,w_200',
  position: 1, // 显示顺序
  config: {},
  privateSchema: {
    // subContainersNumber: 2, // 会有几个子容器
    subContainersNode: [
      {
        componentId: ComponentIdEnum.IMG_COMPONENT,
        config: {
          src: 'https://cdn.resource.youniverse.cc/d2c-app-dev/kblwvCj1_J4VGrXRdwEHd.jpg',
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_TITLE_COMPONENT,
        styles: {
          paddingTop: 20, // 这里是为了移动端的时候有个上边距
        },
        privateSchema: {
          text: 'Solid Whole Bamboo Wood Board & Eco-friendly',
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
        styles: {
          paddingTop: 16,
        },
        privateSchema: {
          // eslint-disable-next-line max-len
          text: 'The eco-friendly and durable bamboo desktop supports sustainable consumption and production patterns. The unique texture in bamboo is a gift from nature, leading us to embrace our nature. Calm down, slow down and enjoy the balance between life and work.',
        },
      },
    ], // 会有几个子容器
    marginRight: 2,
    isReverse: false, // 是否翻转
  },
  category: 'container',
  configForm: ConfigHOC(ConfigForm),
};
